import * as types from './types'
import actions from './actions'
import getters from './getters'


const state = {
  listAttachments: null,
  isFetching: false,
  isUploading: false,
  isDownloading: false
}

const initialState = {
  listAttachments: null,
  isFetching: false,
  isUploading: false,
  isDownloading: false
}

const mutations = {
  [types.IS_FETCHING](state, action) {
    state.isFetching = action.flag
  },
  [types.IS_UPLOADING](state, action) {
    state.isUploading = action.flag
  },
  [types.IS_DOWNLOADING](state, action) {
    state.isDownloading = action.flag
  },
  [types.SET_LIST_ATTACHMENTS](state, action) {
    state.listAttachments = action.listAttachments
  },
  [types.REMOVE_ATTACHMENT](state, action) {
    const index = state.listAttachments.findIndex(({ s3Key }) => (s3Key === action.s3Key))
    if (index >= 0) {
      state.listAttachments.splice(index, 1)
    }
  },
  [types.RESET_STATE](state, action) {
    Object.assign(state, initialState)
  }
}

export const attachments = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
